"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;

var sha256_1 = __importDefault(require("sha256"));

var axios_1 = __importDefault(require("axios"));

var models_1 = require("../models");

var constants_1 = require("../constants");

var stellar_sdk_1 = require("stellar-sdk");

var utils_1 = require("../utils");

var xdrBuilder_1 = require("../xdrBuilder");

var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));

var rxjs_1 = require("rxjs");

var api_1 = require("../api");
/**
 * User Class
 */


var User;

(function (User) {
  var _this = this;

  var merchantKeypair;
  var secretKey;
  var session;
  /**
    * initialize
    * @param {string} secretKey string.
    */

  User.initialize = function (secretKey) {
    merchantKeypair = stellar_sdk_1.Keypair.fromSecret(secretKey);
  };

  var sessionObserver = rxjs_1.Observable.create(function (observer) {
    if (localStorage.getItem("niftoken") != null) {
      var token = localStorage.getItem("niftoken");

      if (token != null) {
        jsonwebtoken_1.default.verify(token, "ijk3dp4n", function (err, decodedToken) {
          if (err || !decodedToken) {
            localStorage.removeItem("niftoken");
            observer.error(new Error("no token"));
          } else {
            session = decodedToken;
            observer.next(session);
            observer.error(null);
            observer.complete();
          }
        });
      }
    }

    observer.error(new Error("no token"));
  });
  /**
   * onAuthStateChanged
   * @param {UserModel} authUser UserModel.
   * @param {Error} error Error.
  */

  User.onAuthStateChanged = function (authUser, _error) {
    if (authUser === void 0) {
      authUser = function authUser(val) {
        return val;
      };
    }

    if (_error === void 0) {
      _error = function error(err) {
        return err;
      };
    }

    sessionObserver.subscribe({
      next: function next(value) {
        return authUser(value);
      },
      error: function error(e) {
        return _error(e);
      },
      complete: function complete() {
        return console.log('complete');
      }
    });
  };
  /**
   * getCurrentUser
   * @param {UserModel} authUser UserModel.
   * @param {Error} error Error.
  */


  User.getCurrentUser = function (authUser, _error2) {
    if (authUser === void 0) {
      authUser = function authUser(val) {
        return val;
      };
    }

    if (_error2 === void 0) {
      _error2 = function error(err) {
        return err;
      };
    }

    sessionObserver.subscribe({
      next: function next(value) {
        return authUser(value);
      },
      error: function error(e) {
        return _error2(e);
      },
      complete: function complete() {
        return console.log('complete');
      }
    });
  };
  /**
   * logout
   */


  User.logout = function () {
    localStorage.removeItem("niftoken");
    window.location.assign(window.location.href);
  };
  /**
  * authRedirect
  * @param {AuthModel} authModel AuthModel.
  */


  User.authRedirect = function (authModel, test) {
    try {
      var query = ""; //add redirect url

      if (authModel.redirectUrl && authModel.redirectUrl != "") {
        var RedirectUrl = authModel.redirectUrl;
        query += "redirectUrl=" + encodeURI(RedirectUrl);
      } //add merchantKey


      query += "&merchantKey=" + merchantKeypair.publicKey(); //add merchantAuthType

      if (authModel.merchantAuthType) {
        var MerchantAuth = authModel.merchantAuthType ? authModel.merchantAuthType : models_1.MerchantAuthType.REGULAR;
        query += "&merchantAuthType=" + encodeURI(MerchantAuth);
      } //add user account type


      if (authModel.userType) {
        var userType = authModel.userType;
        query += "&type=" + encodeURI(userType);
      } //add warning


      if (authModel.warning) {
        var warning = authModel.warning;
        query += "&warning=" + encodeURI(warning);
      } // const authLink = `https://auth.niftron.com/?${query}`


      var authLink = test ? "https://dev.auth.niftron.com/?" + query : "https://auth.niftron.com/?" + query;
      window.location.assign(authLink);
    } catch (err) {
      throw err;
    }
  };
  /**
   * register niftron user
   * @param {UserType} type UserType.
   * @param {string} alias string.
   * @param {string} email string.
   * @param {string} password string.
   * @param {string} recoveryQuestion string.
   * @param {string} securityAnswer string.
   * @param {Keypair} keypair Keypair.
   * @param {UserAuthType} authType UserAuthType.
   * @returns {string} niftronId string
   */


  var register = function register(type, alias, email, password, recoveryQuestion, securityAnswer, keypair, authType) {
    return __awaiter(_this, void 0, void 0, function () {
      var publicKey, pash, encryptedSecret, encryptedRecoverySecret, _a, xdrs_1, secondaryPublicKey, accounts, postBody, res, err_1;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 4,, 5]);

            publicKey = keypair.publicKey();
            pash = "";
            encryptedSecret = "";
            encryptedRecoverySecret = "";

            if (password != "") {
              pash = sha256_1.default(password);
              encryptedSecret = utils_1.Utils.encryptSecret(keypair.secret(), pash);
            }

            if (securityAnswer != "") {
              encryptedRecoverySecret = utils_1.Utils.encryptSecret(keypair.secret(), sha256_1.default(securityAnswer.toLowerCase()));
            }

            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.register(keypair.publicKey())];

          case 1:
            _a = _b.sent(), xdrs_1 = _a.xdrs, secondaryPublicKey = _a.secondaryPublicKey;
            return [4
            /*yield*/
            , Promise.all(xdrs_1.map(function (item, index, array) {
              return __awaiter(_this, void 0, void 0, function () {
                var _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      _a = xdrs_1[index];
                      return [4
                      /*yield*/
                      , xdrBuilder_1.XDRBuilder.signXDR(item.xdr, keypair.secret())];

                    case 1:
                      _a.xdr = _b.sent();
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }))];

          case 2:
            _b.sent();

            accounts = [];
            accounts.push({
              publicKey: keypair.publicKey(),
              accountType: "0"
            });
            accounts.push({
              publicKey: secondaryPublicKey,
              accountType: "1"
            });
            postBody = {
              type: type,
              alias: alias.toLowerCase(),
              email: email != "" ? email.toLowerCase() : "",
              publicKey: publicKey,
              encryptedSecret: encryptedSecret,
              encryptedRecoverySecret: encryptedRecoverySecret,
              recoveryQuestion: recoveryQuestion,
              authType: authType,
              accounts: accounts,
              xdrs: xdrs_1
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronUserLambda + "/users/register", postBody, {
              headers: {
                // 'Authorization': "bearer " + token,
                "Content-Type": "application/json"
              }
            })];

          case 3:
            res = _b.sent();

            if (res == null) {
              return [2
              /*return*/
              , null];
            }

            if (res.status == 200) {
              localStorage.setItem("niftoken", res.data.data.token);
              return [2
              /*return*/
              , res.status];
            }

            return [2
            /*return*/
            , res.status];

          case 4:
            err_1 = _b.sent();
            console.log("register: " + err_1);
            throw err_1;

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Fund Account In Testnet
   * @param {string} publicKey string.
   * @returns {boolean} response boolean
   */


  var fundAccountInTestnet = function fundAccountInTestnet(publicKey) {
    return __awaiter(_this, void 0, void 0, function () {
      var STELLAT_FRIEND_BOT_URL, stellarResponse, err_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            STELLAT_FRIEND_BOT_URL = "https://friendbot.stellar.org/?addr=";
            return [4
            /*yield*/
            , axios_1.default.get("" + STELLAT_FRIEND_BOT_URL + publicKey)];

          case 1:
            stellarResponse = _a.sent();

            if (stellarResponse !== null && stellarResponse.status !== 200) {
              throw new Error("test bot failed");
            }

            return [2
            /*return*/
            , true];

          case 2:
            err_2 = _a.sent();
            throw err_2;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Create High Privacy Niftron User
   * @param {HighPrivacyUserCreation} options HighPrivacyUserCreation.
   * @returns {HighPrivacyAccountResponse} result HighPrivacyAccountResponse
   */


  User.createHighPrivacyUser = function (options) {
    return __awaiter(_this, void 0, void 0, function () {
      var keypair, result, response, err_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            keypair = stellar_sdk_1.Keypair.random();
            result = {
              status: "Account created successfully"
            };
            return [4
            /*yield*/
            , register(options.type, options.alias, "", "", "", "", keypair, models_1.UserAuthType.HIGHPRIVACY)];

          case 1:
            response = _a.sent();

            if (response === null) {
              throw new Error("Registration failed");
            }

            if (response === 202) {
              throw new Error("Alias already used"); // result.status = "Alias already used";
              // return result;
            }

            secretKey = keypair.secret();
            result.publicKey = keypair.publicKey();
            result.secretKey = keypair.secret();
            return [2
            /*return*/
            , result];

          case 2:
            err_3 = _a.sent();
            throw err_3;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Create High Privacy Niftron User
   * @param {MediumPrivacyAccountCreation} options MediumPrivacyAccountCreation.
   * @returns {MediumPrivacyAccountResponse} result MediumPrivacyAccountResponse
   */


  User.createMediumPrivacyUser = function (options) {
    return __awaiter(_this, void 0, void 0, function () {
      var keypair, result, response, err_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            keypair = stellar_sdk_1.Keypair.random();
            result = {
              status: "Account created successfully"
            };
            return [4
            /*yield*/
            , register(options.type, options.alias, "", options.password, "", "", keypair, models_1.UserAuthType.MEDIUMPRIVACY)];

          case 1:
            response = _a.sent();

            if (response === null) {
              throw new Error("Registration failed");
            }

            if (response === 202) {
              throw new Error("Alias already used");
            }

            if (response === 201) {
              throw new Error("Email already used");
            }

            secretKey = keypair.secret();
            result.publicKey = keypair.publicKey();
            result.secretKey = keypair.secret();
            return [2
            /*return*/
            , result];

          case 2:
            err_4 = _a.sent();
            throw err_4;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Create High Privacy Niftron User
   * @param {LowPrivacyUserCreation} options LowPrivacyUserCreation.
   * @returns {LowPrivacyAccountResponse} result LowPrivacyAccountResponse
   */


  User.createLowPrivacyUser = function (options) {
    return __awaiter(_this, void 0, void 0, function () {
      var keypair, result, response, err_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            keypair = stellar_sdk_1.Keypair.random();
            result = {
              status: "Account created successfully"
            };
            return [4
            /*yield*/
            , register(options.type, options.alias, options.email, options.password, options.recoveryQuestion, options.securityAnswer, keypair, models_1.UserAuthType.LOWPRIVACY)];

          case 1:
            response = _a.sent();

            if (response === null) {
              throw new Error("Registration failed");
            }

            if (response === 202) {
              throw new Error("Alias already used");
            }

            if (response === 201) {
              throw new Error("Alias already used");
            }

            secretKey = keypair.secret();
            result.publicKey = keypair.publicKey();
            result.secretKey = keypair.secret();
            return [2
            /*return*/
            , result];

          case 2:
            err_5 = _a.sent();
            throw err_5;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Login
   * @param {string} key string.
   * @param {string} password string.
   * @returns {Promise<NiftronAccount>} response Promise<NiftronAccount>
   */


  User.login = function (key, password) {
    return __awaiter(_this, void 0, void 0, function () {
      var user, pash, postBody, res, err_6;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            return [4
            /*yield*/
            , api_1.getAccountById(key)];

          case 1:
            user = _a.sent();

            if (user == null) {
              throw new Error("Account not found in niftron");
            }

            pash = sha256_1.default(password);
            postBody = {
              key: key,
              password: pash
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronUserLambda + "/users/login", postBody, {
              headers: {
                // 'Authorization': "bearer " + token,
                "Content-Type": "application/json"
              }
            })];

          case 2:
            res = _a.sent();

            if (res == null) {
              throw new Error("Failed to log in");
            }

            switch (res.status) {
              case 200:
                localStorage.setItem("niftoken", res.data.data.token);
                return [2
                /*return*/
                , user];

              case 201:
                throw new Error("Password is incorrect");

              case 202:
                throw new Error("Activate merchant account first");

              case 203:
                throw new Error("You are a high privacy user try secret key login");

              case 400:
                throw new Error("Failed to log in");

              default:
                throw new Error("Failed to log in");
            }

            return [3
            /*break*/
            , 4];

          case 3:
            err_6 = _a.sent();
            throw err_6;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
     * Login with Secret
     * @param {string} secretKey string.
     * @returns {Promise<NiftronAccount>} response Promise<NiftronAccount>
     */


  User.loginWithSecret = function (secretKey) {
    return __awaiter(_this, void 0, void 0, function () {
      var user, keypair, xdr, postBody, res, err_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4,, 5]);

            return [4
            /*yield*/
            , api_1.getAccountById(stellar_sdk_1.Keypair.fromSecret(secretKey).publicKey())];

          case 1:
            user = _a.sent();

            if (user == null) {
              throw new Error("Account not found in niftron");
            }

            keypair = stellar_sdk_1.Keypair.fromSecret(secretKey);
            return [4
            /*yield*/
            , buildLoginXDR(keypair)];

          case 2:
            xdr = _a.sent();

            if (xdr === null) {
              throw new Error("Login xdr building failed ");
            }

            postBody = {
              xdr: xdr
            };
            return [4
            /*yield*/
            , axios_1.default.post(constants_1.niftronUserLambda + "/users/xdrLogin", postBody, {
              headers: {
                // 'Authorization': "bearer " + token,
                "Content-Type": "application/json"
              }
            })];

          case 3:
            res = _a.sent();

            if (res == null) {
              throw new Error("Failed to log in");
            }

            switch (res.status) {
              case 200:
                localStorage.setItem("niftoken", res.data.data.token);
                return [2
                /*return*/
                , user];

              case 201:
                throw new Error("Password is incorrect");

              case 202:
                throw new Error("Activate merchant account first");

              case 203:
                throw new Error("You are a high privacy user try secret key login");

              case 400:
                throw new Error("Failed to log in");

              default:
                throw new Error("Failed to log in");
            }

            return [3
            /*break*/
            , 5];

          case 4:
            err_7 = _a.sent();
            throw err_7;

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
       * build login xdr
       * @param {Keypair} keypair Keypair.
       * @returns {string|null} response string|null
       */


  var buildLoginXDR = function buildLoginXDR(keypair) {
    return __awaiter(_this, void 0, void 0, function () {
      var server, sourceAccount, networkPassphrase, err2_1, transaction, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 5,, 6]);

            server = new stellar_sdk_1.Server(constants_1.StellarUrlTest);
            sourceAccount = void 0;
            networkPassphrase = void 0;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , server.loadAccount(keypair.publicKey())];

          case 2:
            sourceAccount = _a.sent();
            networkPassphrase = stellar_sdk_1.Networks.TESTNET;
            return [3
            /*break*/
            , 4];

          case 3:
            err2_1 = _a.sent();
            return [2
            /*return*/
            , null];

          case 4:
            transaction = new stellar_sdk_1.TransactionBuilder(sourceAccount, {
              fee: "150",
              networkPassphrase: networkPassphrase
            }).addOperation(stellar_sdk_1.Operation.manageData({
              name: 'login',
              value: new Date().toUTCString()
            })).setTimeout(0).build();
            transaction.sign(keypair);
            return [2
            /*return*/
            , transaction.toEnvelope().toXDR('base64')];

          case 5:
            e_1 = _a.sent();
            return [2
            /*return*/
            , null];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  }; // /**
  //  * Download Credentials
  //  */
  // export const downloadCredentials = async () => {
  //   try {
  //     var FileSaver = require("file-saver");
  //     var blob = new Blob([btoa(JSON.stringify({ secretKey: secretKey }))], {
  //       type: "text/plain;charset=utf-8",
  //     });
  //     FileSaver.saveAs(blob, "credential.niftron");
  //   } catch (err) {
  //     throw err;
  //   }
  // };

  /**
  * Activate Live Net User
  * @param {ActivateUserModel} activateUserModel ActivateUserModel
  * @returns {Promise<NiftronAccount>} niftronId Promise<NiftronAccount>
  */


  User.activateLiveNetUser = function (activateUserModel) {
    return __awaiter(_this, void 0, void 0, function () {
      var user, goLiveXdr, signedGoLiveXdr, goLiveRes, activateXdr, signedActivateXdr, activateRes, err_8;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 8,, 9]);

            return [4
            /*yield*/
            , api_1.getAccountById(activateUserModel.userKeypair.publicKey())];

          case 1:
            user = _a.sent();

            if (user == null) {
              throw new Error("Creator account not found in niftron");
            }

            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.goLive(activateUserModel.userKeypair.publicKey(), merchantKeypair.publicKey())];

          case 2:
            goLiveXdr = _a.sent();
            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.signXDR(goLiveXdr, merchantKeypair.secret()) //submit go live xdr
            ];

          case 3:
            signedGoLiveXdr = _a.sent();
            return [4
            /*yield*/
            , api_1.goLive(activateUserModel.userKeypair.publicKey(), merchantKeypair.publicKey(), signedGoLiveXdr)];

          case 4:
            goLiveRes = _a.sent();

            if (goLiveRes == null) {
              throw new Error("Failed to go live xdr to NIFTRON");
            }

            switch (goLiveRes) {
              case 201:
                throw new Error("Merchant not found");

              case 202:
                throw new Error("Activate merchant account first");

              case 203:
                throw new Error("Account not found");

              case 204:
                throw new Error("User account is already activated");

              case 205:
                throw new Error("Insufficient fund in account");

              case 400:
                throw new Error("Failed to go live xdr to NIFTRON");
            }

            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.activate(activateUserModel.userKeypair.publicKey(), merchantKeypair.publicKey())];

          case 5:
            activateXdr = _a.sent();
            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.signXDR(activateXdr, activateUserModel.userKeypair.secret()) //submit activate xdr
            ];

          case 6:
            signedActivateXdr = _a.sent();
            return [4
            /*yield*/
            , api_1.goLive(activateUserModel.userKeypair.publicKey(), merchantKeypair.publicKey(), signedActivateXdr)];

          case 7:
            activateRes = _a.sent();

            if (activateRes == null) {
              throw new Error("Failed to activate xdr to NIFTRON");
            }

            switch (activateRes) {
              case 200:
                return [2
                /*return*/
                , user];

              case 201:
                throw new Error("Merchant not found");

              case 202:
                throw new Error("Activate merchant account first");

              case 203:
                throw new Error("Account not found");

              case 204:
                throw new Error("User account is not live");

              case 205:
                throw new Error("Insufficient fund in account");

              case 400:
                throw new Error("Failed to activate xdr to NIFTRON");
            }

            return [2
            /*return*/
            , user];

          case 8:
            err_8 = _a.sent();
            console.log("Certificate minting error" + err_8);
            throw err_8;

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  }; // export const getCredentials = () => {
  //   try {
  //     return JSON.stringify({ secretKey: secretKey });
  //   } catch (err) {
  //     throw err;
  //   }
  // };

})(User = exports.User || (exports.User = {}));